import React from 'react';
import I18n from 'i18n-js';

import { PriceDisplay } from '@reverbdotcom/commons';
import PriceDisplayRange from '@reverbdotcom/commons/src/components/price_display_range';
import { reverb_pricing_PriceRecommendation } from '@reverbdotcom/commons/src/gql/graphql';
import { RCButton, RCFlex, RCText } from '@reverbdotcom/cadence/components';

import { parseAmountCents } from '@reverbdotcom/commons/src/money';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';

const MINIMUM_PRICE_LOW = 0;
export const COMPONENT_NAME = 'RenewListingPriceRecommendation';
interface IExternalProps {
  cspSlug: string;
  priceRecommendation?: reverb_pricing_PriceRecommendation;
  updatePrice: React.Dispatch<any>;
}

export default function RenewListingPriceRecommendation({
  cspSlug,
  priceRecommendation,
  updatePrice,
}: IExternalProps) {
  const { priceLow, priceMiddle, priceHigh } = priceRecommendation ?? {};
  const hasDataServicesPriceEstimate = !!priceLow && !!priceMiddle && !!priceHigh;

  if (!hasDataServicesPriceEstimate) return null;

  const showEstimatedPriceRange = priceLow.amountCents > MINIMUM_PRICE_LOW;

  return (
    <div className="renew-listing-modal__price-recommendation">
      <RCFlex gap="2" direction="row" justify="space-between" align="center">
        <div className="mr-1">
          <RCText size="400" weight="bold">
            {I18n.t('discovery.listingsManagement.renewListing.modal.priceGuidance.competitivePrice')}

            <PriceDisplay
              amountCents={priceMiddle.amountCents}
              display={parseAmountCents(
                priceMiddle.amountCents,
                priceMiddle.currency,
                { precision: 0 },
              ).display}
            />
          </RCText>
        </div>
        <div className="renew-listing-modal__apply-button">
          <RCButton
            onClick={() => updatePrice(priceMiddle.amount)}
            size="mini"
            variant="muted"
          >
            {I18n.t('discovery.listingsManagement.renewListing.modal.priceGuidance.apply')}
          </RCButton>
        </div>
      </RCFlex>
      {showEstimatedPriceRange && (
        <RCFlex direction="col" gap="1">
          <div className="renew-listing-modal__price-recommendation__price-range">
            <RCText htmlTag="span" color="rc-color-text-secondary">
              {I18n.t('discovery.listingsManagement.renewListing.modal.priceGuidance.estPriceRange') + ' '}

              <PriceDisplayRange
                moneyLow={priceLow}
                moneyHigh={priceHigh}
                displayConfig={{ precision: 0 }}
              />
            </RCText>
          </div>
          <RCText size="350" color="rc-color-text-secondary">
            {I18n.t('discovery.listingsManagement.renewListing.modal.priceGuidance.description')}
          </RCText>
          <CoreLink
            className="color-secondary td-underline"
            to={Paths.csp.expand({ cspSlug, anchor: 'price-guide' })}
            target="_blank"
          >
            <RCText size="350" color="rc-color-text-secondary">
              {I18n.t('discovery.listingsManagement.renewListing.modal.priceGuidance.pricingInfo')}
            </RCText>
          </CoreLink>
        </RCFlex>
      )}
    </div>
  );
}
